import React from 'react';
import "../CSS/PrecisaMIS.css";
import Accordion from './Accordion';


const PrecisaFAQ = () => {
  return (
    <div>
      <div className='space'>
       <Accordion/> 
      </div>
      
    </div>
  )
}




export default PrecisaFAQ
